angular.module("auth")
    .controller('AuthRegisterWebauthnCtrl', ['$translate', '$scope', 'LoginService', '$rootScope', '$uibModal', '$http', '$state', 'modalService', 'Restangular', '$stateParams', '$location', '$httpParamSerializer', '$timeout', 'logService', function ($translate, $scope, LoginService, $rootScope, $uibModal, $http, $state, modalService, Restangular, $stateParams, $location, $httpParamSerializer, $timeout, logService) {
        $scope.userToken = $stateParams.token;
        $rootScope.loginProcess = false;

        let coerceToBase64Url = function (thing) {
            // Array or ArrayBuffer to Uint8Array
            if (Array.isArray(thing)) {
                thing = Uint8Array.from(thing);
            }

            if (thing instanceof ArrayBuffer) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to base64
            if (thing instanceof Uint8Array) {
                var str = "";
                var len = thing.byteLength;

                for (var i = 0; i < len; i++) {
                    str += String.fromCharCode(thing[i]);
                }
                thing = window.btoa(str);
            }

            if (typeof thing !== "string") {
                throw new Error("could not coerce to string");
            }

            // base64 to base64url
            // NOTE: "=" at the end of challenge is optional, strip it off here
            thing = thing.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");

            return thing;
        };

        let coerceToArrayBuffer = function (thing) {
            if (typeof thing === "string") {
                // base64url to base64
                thing = thing.replace(/-/g, "+").replace(/_/g, "/");

                // base64 to Uint8Array
                var str = window.atob(thing);
                var bytes = new Uint8Array(str.length);
                for (var i = 0; i < str.length; i++) {
                    bytes[i] = str.charCodeAt(i);
                }
                thing = bytes;
            }

            // Array to Uint8Array
            if (Array.isArray(thing)) {
                thing = new Uint8Array(thing);
            }

            // Uint8Array to ArrayBuffer
            if (thing instanceof Uint8Array) {
                thing = thing.buffer;
            }

            // error if none of the above worked
            if (!(thing instanceof ArrayBuffer)) {
                throw new TypeError("could not coerce to ArrayBuffer");
            }

            return thing;
        };

        let registerNewCredential = function (newCredential) {
            // Move data into Arrays incase it is super long
            let attestationObject = new Uint8Array(newCredential.response.attestationObject);
            let clientDataJSON = new Uint8Array(newCredential.response.clientDataJSON);
            let rawId = new Uint8Array(newCredential.rawId);

            const data = {
                id: newCredential.id,
                rawId: coerceToBase64Url(rawId),
                type: newCredential.type,
                extensions: newCredential.getClientExtensionResults(),
                response: {
                    attestationObject: coerceToBase64Url(attestationObject),
                    clientDataJSON: coerceToBase64Url(clientDataJSON)
                }
            };

            Restangular.all('Auth').customPOST(JSON.stringify(data), 'WebAuthn/MakeCredential/' + $scope.userToken, null, {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }).then(function (response) {
                logService.debug("Credential Object", response);

                // show error
                if (response.status !== "ok") {
                    logService.error("Error creating credential");
                    logService.error(response.errorMessage);
                } else {
                    $state.go('authinit');
                    
                }
            });
        }

        $scope.addCredentials = function () {
            Restangular.all("Auth").customPOST(null, "WebAuthn/MakeCredentialOptions/" + $scope.userToken, null).then(function (makeCredentialOptions) {
                logService.debug(makeCredentialOptions);
                if(makeCredentialOptions.status === "ok") {
                    // Turn the challenge back into the accepted format of padded base64
                    makeCredentialOptions.challenge = coerceToArrayBuffer(makeCredentialOptions.challenge);
                    // Turn ID into a UInt8Array Buffer for some reason
                    makeCredentialOptions.user.id = coerceToArrayBuffer(makeCredentialOptions.user.id);

                    makeCredentialOptions.excludeCredentials = makeCredentialOptions.excludeCredentials.map((c) => {
                        c.id = coerceToArrayBuffer(c.id);
                        return c;
                    });

                    if (makeCredentialOptions.authenticatorSelection.authenticatorAttachment === null) makeCredentialOptions.authenticatorSelection.authenticatorAttachment = undefined;

                    logService.debug("Creating PublicKeyCredential...");

                    let newCredential;
                    try {
                        navigator.credentials.create({
                            publicKey: makeCredentialOptions
                        }).then(function (newCredential) {
                            logService.debug("PublicKeyCredential Created", newCredential);
                            registerNewCredential(newCredential);
                        });
                    } catch (e) {
                        let msg = "Could not create credentials in browser. Probably because the username is already registered with your authenticator. Please change username or authenticator."
                        logService.error(msg, e);
//                        showErrorAlert(msg, e);
                    }
                }
            });
        };
    }]);
